import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

// Request interceptor - Add token to all requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - Handle errors globally
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            // Handle 401 Unauthorized - Token expired or invalid
            if (error.response.status === 401) {
                localStorage.removeItem('token');
                // Removed hard redirect to prevent "jumping" to login on background errors
                // window.location.href = '/login'; 
            }

            // Handle 403 Forbidden - No permission
            if (error.response.status === 403) {
                console.error('Access denied:', error.response.data.error);
            }

            // Handle 500 Server Error
            if (error.response.status === 500) {
                console.error('Server error:', error.response.data.error);
            }
        } else if (error.request) {
            // Network error
            console.error('Network error - server not reachable');
        }

        return Promise.reject(error);
    }
);

export default api;
